import React, { useState, useEffect } from 'react';
import { Users, Mic, Calendar, BarChart, Code, Database, Server, Globe, ChevronDown } from 'lucide-react';

import saas from './venture-1.jpg';
import shareMeImg from './venture-2.png';
import foodDeliveryImg from './venture-3.jpg';

const ProjectShowcase = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const images = [saas, shareMeImg, foodDeliveryImg];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 2000);

    return () => clearInterval(interval);
  }, [images]);

  const handleDotClick = (index) => {
    setCurrentImageIndex(index);
  };

  const projects = [
    {
      title: "Mentorship Matchmaking Platform",
      link: 'https://github.com/kevinrajgor/mentorship-matchmaking-platform',
      icon: <Users size={16} />,
    },
    {
      title: "Real-time Voice Communication Task Manager",
      link: 'https://github.com/Ashishkr05/Voice-communication-app',
      icon: <Mic size={16} />,
    },
    {
      title: "Startup Growth Tracker",
      link: 'https://github.com/Ashishkr05/Task-Manager-Application/tree/master',
      icon: <BarChart size={16} />,
    }
  ];

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const features = [
    { text: "🤝 Mentor-Startup Matching Algorithm" },
    { text: "📅 Google Calendar Integration" },
    { text: "🎙️ Real-time Voice Communication" },
    { text: "📊 Growth Metrics Dashboard" },
    { text: "👥 User Profiles for Mentors and Startups" },
    { text: "📋 Task Management System" }
  ];
  
  const technologies = [
    { text: "⚛️ React.js & Next.js (Frontend)" },
    { text: "🟢 Node.js & Express.js (Backend)" },
    { text: "🍃 MongoDB (Database)" },
    { text: "🔗 RESTful API & GraphQL" },
    { text: "🎙️ WebRTC for Voice Communication" },
    { text: "📅 Google Calendar API Integration" }
  ];

  return (
    <div className="project-showcase">
      <div className="showcase-content">
        <div className="image-carousel">
          <img
            src={images[currentImageIndex]}
            alt={`Project ${currentImageIndex + 1}`}
          />
          <div className="dots-container">
            {images.map((_, index) => (
              <span
                key={index}
                className={`dot ${currentImageIndex === index ? 'active' : ''}`}
                onClick={() => handleDotClick(index)}
              />
            ))}
          </div>
        </div>
        <div className="project-details">
          <h2>💡Venture Studio Growth Solutions</h2>
          <p>
          I built this to provide comprehensive tools for startup development, mentorship, and collaboration. These solutions streamline the process of connecting startups with mentors, offering key features like real-time communication, task management, and progress tracking. The goal is to empower startups with the resources needed to accelerate growth and foster innovation. Each project in this category is designed to enhance productivity, facilitate mentorship, and drive collaboration for emerging ventures.
          </p>
          <div className="features-technologies">
            <div className="column">
              <h3>Key Features</h3>
              {features.map((item, index) => (
                <div key={index} className="item">
                  <span>{item.text}</span>
                </div>
              ))}
            </div>
            <div className="column">
              <h3>Technologies Used</h3>
              {technologies.map((item, index) => (
                <div key={index} className="item">
                  <span>{item.text}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="project-dropdown">
            <button className="dropdown-button" onClick={toggleDropdown}>
              Explore Venture Studio Solutions <ChevronDown size={16} />
            </button>
            <div className={`dropdown-content ${dropdownOpen ? 'show' : ''}`}>
              {projects.map((project, index) => (
                <a
                  key={index}
                  href={project.link}
                  className="project-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {project.icon}
                  <span>{project.title}</span>
                </a>
              ))}
            </div>
          </div>
          <p className="dropdown-note">Click on a product to view detailed information and start your growth journey.</p>
        </div>
      </div>
    </div>
  );
};

export default ProjectShowcase;